import script from "./pop-page.vue?vue&type=script&setup=true&lang=js"
export * from "./pop-page.vue?vue&type=script&setup=true&lang=js"

import "./pop-page.vue?vue&type=style&index=0&id=ec5e8b8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec5e8b8c"]])

export default __exports__